export const createClearActions = (set: any, get: any) => ({
  clearAccountsForInstitution: (institutionId: string) => {
    get().setAccountsForInstitution(institutionId, []);
    get().setAccountsErrorForInstitution(institutionId, null);
  },

  clearAllAccounts: () => {
    const state = get();
    const institutionIds = Array.from(state.connections.keys());
    institutionIds.forEach((institutionId: string) => {
      get().clearAccountsForInstitution(institutionId);
    });
  },
});
